import LocalizedImage from '@CS/components/LocalizedImage';
import Images, { Logo } from '@/assets/images';
import { useNavigateQuery } from '@/hooks';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import CSS from './Done.module.css';
import Content from './content';

export const Done = () => {
  const {
    title,
    description,
    button,
    terms,
    termsLabel,
    termsLink
  } = useTranslation(Content);

  const navigate = useNavigateQuery();
  const onClick = () => navigate('/');

  return (
    <section className={CSS.doneScreen} aria-label="Done">
      <img alt="Logo" src={Logo} />
      <LocalizedImage name="The Good Trivia" images={Images.Intro} />

      <div className={CSS.descriptionContainer}>
        <h4>{title}</h4>
        <p>{description}</p>
        <Button text={button} onClick={onClick} />
      </div>

      <span className={CSS.termsLabel}>
        {terms}{' '}
        <a title={termsLabel} href={termsLink}>
          {termsLabel}
        </a>
      </span>
    </section>
  );
};
